import { useCallback } from "react";
import { useSDK } from "@contentful/react-apps-toolkit";
import { GlossaryId, GlossaryLocalePair } from "../lib";
import { getPlanFromCredentials } from "../utils";

export const useDeleteDeeplDictionary = () => {
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const deleteDeeplDictionary = useCallback(
        async (glossaryId: GlossaryId, localePair: GlossaryLocalePair): Promise<void> => {
            if (!deeplCredentials) {
                throw new Error("Missing DeepL credentials");
            }

            const plan = getPlanFromCredentials(deeplCredentials);

            const response = await fetch(
                `/api/${plan}/v3/glossaries/${glossaryId}/dictionaries?source_lang=${localePair.source}&target_lang=${localePair.target}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `DeepL-Auth-Key ${deeplCredentials}`,
                        Connection: "keep-alive",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Error deleting DeepL dictionary. Status: ${response.status}`);
            }
        },
        [deeplCredentials]
    );
    return { deleteDeeplDictionary };
};
